const convertToCSV = (
  objArray,
  dailyTargetsHistoryJsonObject,
  exportDate,
  participantId,
  protocolNumber,
  reportName
) => {
  const mealsArray =
    typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  const header = `Report Name,${reportName},,,\r\nReport Date,${exportDate},,,\r\nProtocol Number,${protocolNumber?.toUpperCase()},,,\r\nParticipant ID,${participantId}\r\n\r\n`;
  let str = header;

  for (let i = 0; i < mealsArray.length; i++) {
    let line = "";
    for (let index in mealsArray[i]) {
      if (line !== "") line += ",";

      line += mealsArray[i][index];
    }

    str += line + "\r\n";
  }

  if (dailyTargetsHistoryJsonObject) {
    const historyArray =
      typeof dailyTargetsHistoryJsonObject !== "object"
        ? JSON.parse(dailyTargetsHistoryJsonObject)
        : dailyTargetsHistoryJsonObject;

    str += "\r\n\r\n\r\n\r\n\r\n";
    str += "Targets history";
    str += "\r\n\r\n";
    str += "Date,Calories (kcal),LCF (%),MCF (%),Protein (%),Carbohydrates (%)";
    str += "\r\n";

    for (let i = 0; i < historyArray.length; i++) {
      let line = "";
      for (let index in historyArray[i]) {
        if (line !== "") line += ",";

        line += historyArray[i][index];
      }

      str += line + "\r\n";
    }
  }

  return str;
};

export const exportCSVFile = (
  headers,
  items,
  dailyTargetHistory,
  exportDate,
  participantId,
  protocolNumber,
  fileName,
  reportName
) => {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  const mealsJsonObject = JSON.stringify(items);
  const dailyTargetsHistoryJsonObject = JSON.stringify(dailyTargetHistory);

  const csv = convertToCSV(
    mealsJsonObject,
    dailyTargetsHistoryJsonObject,
    exportDate,
    participantId,
    protocolNumber,
    reportName
  );

  const exportedFilenmae = `${fileName}.csv` || "export.csv";

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  return Promise.resolve("success");
};
